import firebase from 'firebase'
import { firebaseAuth } from '../firebase'
import {
  INIT_AUTH,
  PASSWORD_RESET_ERROR,
  PASSWORD_RESET_SUCCESS,
  PROFILE_UPDATE,
  PROFILE_UPDATE_FAILURE,
  PROFILE_UPDATE_SUCCESS,
  REGISTER,
  REGISTER_ERROR,
  REGISTER_SUCCESS,
  SIGN_IN_ERROR,
  SIGN_IN_SUCCESS,
  SIGN_OUT_SUCCESS,
} from './action-types'


export function registerUser(data) {
  return { type: REGISTER, payload: data };
}

export function createUser(email, password) {
  return firebaseAuth.createUserWithEmailAndPassword(email, password)
    .then(user => {

      return user;
    })
}

export function verifyUserEmail(user) {
  if (!user.emailVerified) {
    return user.sendEmailVerification()
      .then(() => user)
  }
  return Promise.resolve(user);
}

export function initAuth(user) {
  return {
    type: INIT_AUTH,
    payload: user,
  }
}

/**
 *
 * @param {object} error
 * @param {string} error.code - firebase validation error code
 * @param {string} error.message - firebase validation error message
 * @return {string}
 */
const getAuthValidationMessageByCode = (error) => {
  const errorMessagesMap = {
    'auth/user-not-found': 'Invalid email or password.',
    'auth/wrong-password': 'Invalid email or password.',
  };

  return errorMessagesMap[error.code] || error.message
}

export function signInError(error) {
  return {
    type: SIGN_IN_ERROR,
    payload: {
      message: getAuthValidationMessageByCode(error)
    },
  }
}

export function signInSuccess(result) {
  return {
    type: SIGN_IN_SUCCESS,
    payload: result,
  }
}

export function registerError(error) {
  return {
    type: REGISTER_ERROR,
    payload: error,
  }
}

export function registerSuccess(result) {
  return {
    type: REGISTER_SUCCESS,
    payload: result,
  }
}

export function passwordResetError(error) {
  return {
    type: PASSWORD_RESET_ERROR,
    payload: error,
  }
}

export function passwordResetSuccess(result) {
  return {
    type: PASSWORD_RESET_SUCCESS,
    payload: {
      success: 'Password reset instructions have been sent to your email address.',
      ...result
    },
  }
}

export function updateProfile(email, name, currentPassword, newPassword) {
  return dispatch => {
    const user = firebaseAuth.currentUser
    user
      .reauthenticate(firebase.auth.EmailAuthProvider.credential(email, currentPassword))
      .then(() => {
        dispatch({ type: PROFILE_UPDATE, payload: { email, name, newPassword } });

        const updates = [];
        user.email !== email && updates.push(user.updateEmail(email));
        currentPassword && newPassword && updates.push(user.updatePassword(newPassword));
        user.displayName !== name && user.updateProfile({ displayName: name });

        return Promise.all(updates);
      })
      .then(() => dispatch({ type: PROFILE_UPDATE_SUCCESS, payload: { email, name } }))
      .catch(error => { dispatch({ type: PROFILE_UPDATE_FAILURE, payload: { ...error } }) })
  }
}

export function signInWithEmailPassword(email, password) {
  return dispatch => {
    firebaseAuth.signInWithEmailAndPassword(email, password)
      .then(result => {
        dispatch(signInSuccess(result));
      })
      .catch(error => {
        dispatch(signInError({ ...error }));
      })
  }
}

export function resetPassword(email) {
  return dispatch => {
    firebaseAuth.sendPasswordResetEmail(email)
      .then(result => dispatch(passwordResetSuccess(result)))
      .catch(error => dispatch(passwordResetError({ ...error })))
  }
}

export function signOut() {
  return dispatch => {
    firebaseAuth.signOut()
      .then(() => dispatch(signOutSuccess()))
  }
}

export function signOutSuccess() {
  return {
    type: SIGN_OUT_SUCCESS,
  }
}



// WEBPACK FOOTER //
// ./src/modules/auth/actions.js